import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable, from, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class HttpsRequestInterceptor implements HttpInterceptor {
  constructor(private afAuth: AngularFireAuth) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (req.responseType !== 'json' || !req.url.includes('letsenjoy.it')) {
      return next.handle(req);
    }

    return this.afAuth.authState.pipe(
      take(1),
      switchMap((user) => user ? from(user.getIdToken()) : of(null)),
      switchMap((token) => {
        const authPayload: Record<string, string> = token ? { 'Content-Type': 'application/json', Authorization: token } : { 'Content-Type': 'application/json' };

        const dupReq = req.clone({
          setHeaders: authPayload
        });

        return next.handle(dupReq);
      }),

    );
  }
}
